import * as React from 'react';
import { Link } from 'react-router-dom';
import { MdCable, MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { routeConstants } from 'app/routes/route-constants';
import { When } from './when';
import { MenuAccess } from '../../../types';
import styles from '../mobile-nav.scss';

interface Props {
  translation: any;
  menuAccess: MenuAccess;
  onItemClick: () => void;
}

export const ToolsExperienceTransferMenuItem = ({ translation, menuAccess, onItemClick }: Props) => (
  <When condition={menuAccess.experienceTransferAdministration}>
    <li>
      <input type="checkbox" id="mobile-admin-experience-transfer" />

      <div className={`${styles.dropdownButton} list-group-item`}>
        <MdCable className={styles.navItemIcon} />
        <span className={`${styles.navItemText} ${styles.small}`}>
          {translation.experience_transfer_administration}
        </span>
        <label className={styles.dropdownLabel} htmlFor="mobile-admin-experience-transfer">
          <MdKeyboardArrowDown className={styles.down} />
          <MdKeyboardArrowUp className={styles.up} />
        </label>
      </div>

      <ul className={styles.subMenu}>
        <li className={styles.child} onClick={onItemClick}>
          <Link to={routeConstants.subscriberGroupsList} className="list-group-item">
            <span className={styles.navItemText}>
              {translation.subscriber_groups_administration}
            </span>
          </Link>
        </li>
        <li className={styles.child} onClick={onItemClick}>
          <Link to={routeConstants.subscriberGroupsUserMembers} className="list-group-item">
            <span className={styles.navItemText}>
              {translation.user_members_administration}
            </span>
          </Link>
        </li>
        <li className={styles.child} onClick={onItemClick}>
          <Link to={routeConstants.experienceTransferList} className="list-group-item">
            <span className={styles.navItemText}>
              {translation.experience_transfer_configuration}
            </span>
          </Link>
        </li>
        <li className={styles.child} onClick={onItemClick}>
          <Link to={routeConstants.experienceTransferOperations} className="list-group-item">
            <span className={styles.navItemText}>
              {translation.configure_operations_transfer}
            </span>
          </Link>
        </li>
      </ul>
    </li>
  </When>
);
